import { urlFnBAdmin, urlRetailAdmin } from "../valuables/router.const";

export function getParameterByName(name: string, url = window.location.href) {
  name = name.replace(/[\[\]]/g, "\\$&");
  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function getSsoUrl({
  code,
  websiteUrl,
  platform,
  query,
}: {
  code: string;
  websiteUrl: string;
  platform?: string;
  query?: string;
}) {
  if (platform === "fnb") {
    return `${urlFnBAdmin.sso}?code=${code}&website_url=${websiteUrl}`;
  }
  return `${urlRetailAdmin.sso}?code=${code}&website_url=${websiteUrl}`;
}
